import React from "react";

import { ActivityOverviewPage } from "@harrow-education/ui-components";

const ActivityOverview = (props) => {
  return <ActivityOverviewPage {...props} />;
};

export default ActivityOverview;
